import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PanelType, PrimaryButton, SpinButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import SearchableDropdown from "../../Components/SearchableDropdown";
import NetGrossPicker from "../../Components/NetGrossPicker";
import { MoneyFormat } from "../../Utilities/MoneyFormat";

function AddAgreementElement(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [note, setNote] = useState('');
    const [net, setNet] = useState('0');
    const [vat, setVat] = useState('0');
    const [gross, setGross] = useState('0');
    const [quantity, setQuantity] = useState('1');
    const [addon, setAddon] = useState({ key: null, text: 'Brak' });
    const empty = {key: null, text: 'Brak'};
    const [addons, setAddons] = useState([empty]);

    const _submit = (e) => {
        e.preventDefault();
        let data = {name: name, note: note,
            net_value: net, vat: vat, gross_value: gross, quantity: quantity
        };
        if (props.add?.venture_agreement_id) {
            data.venture_agreement_id = props.add.venture_agreement_id;
        }
        if (props.add?.agreement_protocol_id) {
            data.agreement_protocol_id = props.add.agreement_protocol_id;
        }
        if (addon.key !== null) {
            data.project_addon_id = addon.key;
        }
        fetch(`/api/agreement/element`, {
            method: 'POST',
            body: JSON.stringify({...data}),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err)
            })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddCostAddon'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setAddon({ key: null });
            setNote('');
            setName('');
            setNet(0);
            setGross(0);
            setQuantity(1);

            async function fetchAddons() {
                await fetch(`/api/project/addons/unpaid`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {

                        const formatted = data.map((item) => {
                            return {
                                key: item.id,
                                text: `${item.venture} ${item.project}: ${item.addon}`,
                                name: item.addon,
                                net_total: item.net_total,
                                gross_total: item.gross_total,
                                quantity: item.quantity,
                                internal: item.internal,
                                net_cost: item.base_net_cost,
                                gross_cost: item.base_gross_cost,
                                vat: item.base_vat
                            };
                        });
                        formatted.unshift(empty);
                        setAddons(formatted);
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }

            fetchAddons();

        }
        return () => abortController.abort();
    }, [props.add, user.token])

    useEffect(() => {
        if (addon?.key !== null) {
            setNet(String(addon.net_cost));
            setGross(String(addon.gross_cost));
            setVat(String(addon.vat));
            setName(addon.name);
            setQuantity(String(addon.quantity));
        }
    }, [addon]);

    const internal = addon?.internal ? (<h4 style={{color: 'red'}}>Wewnętrzny</h4>) : '';

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Przypisz Koszt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
            type={PanelType.largeFixed}
        >
            <form onSubmit={_submit} id='AddCostAddon'>
                <SearchableDropdown
                    label="Dodatek"
                    selectedKey={addon ? addon.key : undefined}
                    onChange={(e, item) => setAddon(item)}
                    placeholder="Wybierz z listy"
                    options={addons}
                />
                <TextField maxLength={160} label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField multiline maxLength={255} label='Notatka' value={note} onChange={(e) => setNote(e.target.value || '')}/>
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={'Ilość'}
                    labelPosition={'top'}
                    min={0}
                    step={0.01}
                    max={10000000}
                    incrementButtonAriaLabel={'+1'}
                    decrementButtonAriaLabel={'-1'}
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value || '')}
                />
                <h4>Razem: {MoneyFormat(parseFloat(quantity) * parseFloat(net))} netto, {MoneyFormat(parseFloat(quantity) * parseFloat(gross))} brutto</h4>
                {internal}
            </form>
        </Panel>
    )
}

export default AddAgreementElement;